export const ZOOMS = [6, 12, 24, 72, 168];
const packingColor = '#946000';
export const STATUS = {
  PACKEN: ['PACKEN', packingColor],
  PACKED: ['GEPACKT', packingColor],
  STORAGE: ['LAGER', '#6745ae'],
  LOADING: ['EINLADEN', '#1466ad'],
  EMPTY_CASES: ['LEERGUT', '#10776e'],
  RETURN_FULL: ['RETOURE–VOLLGUT', '#7744a9'],
  EVENT: ['VA', '#a42b69'],
  BLOCKED: ['GESPERRT', '#b12d3b']
};
const packingIcon = '▣';
export const STATUS_ICONS = {PACKEN:packingIcon,PACKED:packingIcon,STORAGE:'⌂',LOADING:'⇧',EMPTY_CASES:'□',RETURN_FULL:'⇩',EVENT:'◆',BLOCKED:'⊘'};
export const RT = {
  GATE: 'Tor',
  LOADING_ZONE: 'Ladezone',
  AREA: 'Fläche',
  STORAGE: 'LAGER',
  DRIVER: 'Fahrer',
  VEHICLE: 'Fahrzeug'
};
export const snap = (v, interval = 900) => Math.round(v / interval) * interval;
export const localValue = unix => {
  if (unix == null || !Number.isFinite(Number(unix))) return '';
  const d = new Date(Number(unix) * 1000);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
export const unixValue = v => Math.floor(new Date(v).getTime() / 1000);
export const timeLabel = (u, date = false) => new Intl.DateTimeFormat('de-DE', {
  ...(date ? {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit'
  } : {}),
  hour: '2-digit',
  minute: '2-digit'
}).format(new Date(Number(u) * 1000));
export const menuPosition = (x, y, count) => ({
  x: Math.max(8, Math.min(x, window.innerWidth - 210)),
  y: Math.max(8, Math.min(y, window.innerHeight - count * 42 - 20))
});
